import React, { useState, useContext } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ButtonUI from "../../material-ui/ButtonUI";
import { TbX } from "react-icons/tb";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import { AuthContext } from "../../../context/Auth/AuthContext";
import unAssignUser from "../../../api/unAssignUser"; // API call to unassign user

const UnassignUserPopup = ({
  selectedRows,
  setDocumentUpdatedToTrue,
  bulkUnassign,
  setBulkUnassign,
  setRowSelection,
  bulkAssignIds,
  createdAt,
  documentSourceDetails,
  caseList,
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkUnassign(false);
  };

  const handleConfirm = async () => {
    try {
      // Call unAssignUser API
      const unAssignUserResponse = await unAssignUser({
        token: token,
        created_at: createdAt,
        document_source_details: documentSourceDetails,
        document_source_type: caseList,
        bulkAssignIds: bulkAssignIds,
      });

      if (unAssignUserResponse.code === 200) {
        setBulkUnassign(false);
        setDocumentUpdatedToTrue();
        setRowSelection({});
        showSuccess("User unassigned successfully");
      } else {
        showError("Error while unassigning the user");
      }
    } catch (error) {
      showError("An error occurred while unassigning the user");
    }

    handleClose(); // Close confirmation dialog after action
  };

  return (
    <Dialog
      open={bulkUnassign}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
        <div className="popup-header-svg-icon">
          <TbX />
        </div>
        <div className="popup-header-title">Unassign User</div>
      </DialogTitle>
      <DialogContent>
        <div>
          Are you sure you want to unassign the user from the selected
          documents?
        </div>
      </DialogContent>
      <DialogActions style={{ justifyContent: "flex-end" }}>
        <ButtonUI
          formButton={false}
          variant="outlined"
          buttonText="No"
          style={{
            backgroundColor: "#fff",
            color: "#1a6b7c",
            border: "1px solid #1a6b7c",
          }}
          onClickFunc={handleClose} // Close the dialog on "No"
        />
        <ButtonUI
          formButton={false}
          variant="outlined"
          buttonText="Yes"
          style={{
            backgroundColor: "#fff",
            color: "#1a6b7c",
            border: "1px solid #1a6b7c",
          }}
          onClickFunc={handleConfirm} // Call the unassign function on "Yes"
          autoFocus
        />
      </DialogActions>
    </Dialog>
  );
};

export default UnassignUserPopup;
